<!-- Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. -->

<div
  class="xrx-navbar"
  [ngClass]="{ home: router.url === '/', owner: isOwner }"
  role="banner">
  <!-- desktop navbar -->
  <div class="dn-navbar-container">
    <!-- brand header -->
    <div class="xrx-brand-header" role="heading" aria-level="1">
      <div
        class="content"
        [ngClass]="{ 'justify-content-between': router.url === '/' }">
        <div class="brand-img">
          <a href="https://www.xerox.com/" target="_blank"
            ><img alt="brand logo" src="/images/xerox-logo-2026.svg"
          /></a>
        </div>
        @if (router.url !== '/') {
          <div class="app-brand-label" xdaTranslate>APPNAME</div>
        }
        @if (displayVersion && router.url !== '/') {
          <div class="version" xdaTranslate>VERSION</div>
        }
        @if (router.url === '/') {
          <nav-account></nav-account>
        }
      </div>
    </div>
    @if (router.url !== '/') {
      <nav class="dn-navbar-nav" (scroll)="onScroll()">
        <div class="dn-inner">
          <ul class="dn-menu dn-level1 clearfix">
            @for (
              menuItem of menuItems | filter: 'canActivate' : true;
              track menuItem
            ) {
              <li class="dn-menu-item dn-level1-item">
                <a
                  [routerLink]="menuItem.route"
                  [routerLinkActive]="['dn-active-pathway']">
                  <i class="dn-level1-item-glyph xgl-check_background"></i>
                  <span
                    class="dn-menu-item-label"
                    [xdaTranslate]="menuItem.label"></span>
                </a>
              </li>
            }
          </ul>
          <!-- utility item -- user account -->
          <nav-account></nav-account>
        </div>
      </nav>
    }
  </div>
  <!-- mobile navbar -->
  <div class="mn-header">
    @if (displayMobileHamburger) {
      <button
        class="mn-open-btn"
        aria-label="Navigation Open Button"
        (click)="toggle()">
        <i class="xgl-menu"></i>
      </button>
    }
    <a class="mn-app-brand" [routerLink]="['/']"
      ><img
        class="d-none"
        alt="brand logo"
        src="/images/xerox-logo-reverse-2026.svg" /><span
        class="mn-app-brand-label"
        xdaTranslate
        >APPNAME</span
      ></a
    >
    <div
      class="mn-navbar-container"
      [ngClass]="{ show: isExpanded }"
      [attr.aria-hidden]="!isExpanded">
      <nav class="mn-navbar-nav">
        <div class="mn-container">
          <div class="mn-inner">
            <button
              class="mn-close-btn"
              aria-label="Navigation Close Button"
              (click)="collapse()">
              <i class="xgl-close"></i>
            </button>
            <ul class="mn-menu mn-level1" id="mn-accordion0">
              @for (
                menuItem of menuItems | filter: 'canActivate' : true;
                track menuItem
              ) {
                <li class="mn-menu-item mn-level1-item">
                  <a
                    [routerLink]="menuItem.route"
                    [routerLinkActive]="['mn-active-pathway']"
                    class="mn-menu-item-link">
                    <i class="mn-level1-item-glyph xgl-check_background"></i>
                    <span
                      class="mn-menu-item-label"
                      [xdaTranslate]="menuItem.label"></span>
                  </a>
                </li>
              }
            </ul>
            <div class="mn-footer">
              <div class="mn-brand-img">
                <a [routerLink]="['/']"
                  ><img
                    alt="brand logo"
                    src="/images/xerox-logo-reverse-2026.svg"
                /></a>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </div>
    <div class="mn-backdrop"></div>
    <!-- utility item -- user account -->
    <nav-account></nav-account>
  </div>
</div>
